import { AustralianStates } from "app/app.types";
import validate from "validate.js";
import { ITableItem } from 'shared-types/SharedTypes';
import TestHelpers from 'app/tests/testHelpers';

const constraints = {
  _id: {
    format: {
      pattern: '^booking_[0-9][0-9][0-9][0-9]-[0-9][0-9]-[0-9][0-9]_[0-9A-Z]{13}_[0-9A-Z]{13}$',
      message: "The booking id is not valid"
    },
  },
  bookedAt: {
    presence: true,
  },
  duration: {
    presence: true,
  },
  method: {
    presence: true,
  },
  people: {
    presence: true,
  },
  time: {
    presence: true,
  },
  type: {
    presence: true,
  },
  bookingRef: {
    presence: true,
  }
};

class UtilsService {

  areSameStringArrays(arrFirst: string[] = null, arrSecond: string[] = null): boolean {
    if (arrFirst === arrSecond) return true;
    if (!(arrFirst && arrSecond)) return false;
    if (arrFirst.length !== arrSecond.length) return false;
    // return arrFirst.every((element, index) => element.normalize() === arrSecond[index].normalize());
    return arrFirst.every((element, index) => element === arrSecond[index]);
  }

  addLinksToText(text: string = null): string {
    if (text == null) return '';
    const urlRegex = /(ftp:\/\/|www\.|https?:\/\/){1}[a-zA-Z0-9u00a1-\uffff0-]{2,}\.[a-zA-Z0-9u00a1-\uffff0-]{2,}(\S*)/ig;
    return text.replace(urlRegex, (url: string) => {
      const urlLink = (url.indexOf('www') === 0) ? 'http://' + url : url;
      return '<a href="' + urlLink + '" target="_blank" tabindex="-100">' + url + '</a>';
    });
  }

  /**
   * Adds state prefix to Australian landline phone numbers
   */
  checkPhoneState(phoneNumber: string, country: string, state: string, removeSpacesAndHyphens: boolean = false): string {
    if (removeSpacesAndHyphens) phoneNumber = phoneNumber.split(' ').join('').split('-').join('');
    if (8 === phoneNumber.length && '0' !== phoneNumber.charAt(0) && 'AU' === country) {
      let stateCode;
      switch (state) {
        case AustralianStates.VIC:
          stateCode = '03';
          break;
        case AustralianStates.TAS:
          stateCode = '03';
          break;
        case AustralianStates.QLD:
          stateCode = '07';
          break;
        case AustralianStates.WA:
          stateCode = '08';
          break;
        case AustralianStates.SA:
          stateCode = '08';
          break;
        case AustralianStates.NT:
          stateCode = '08';
          break;
        default:
          stateCode = '02';
      }
      phoneNumber = stateCode + phoneNumber;
    }
    return phoneNumber;
  }



  // using library https://github.com/ansman/validate.js
  // validateObject(input: any, constraints: object) {
  validateObject(input: any) {
    return validate(input, constraints);
  }

  /**
   * NBI-704: Zooms out phones and tablets
   */
  adjustViewPortSize(): void {
    const longestDimension = Math.max(window.screen.width, window.screen.height);
    const metaVP = document.querySelector('[name="viewport"]');
    // The view port has been set to 78% by default, which works for iPad, but...

    if (longestDimension > 1300) { // iPad pro needs a little less zoom out
      metaVP.setAttribute('content', `width=${ Math.round(longestDimension * 1.2) }`);
    } else if (longestDimension < 1000) { // while smaller android devices need a little more zoom out
      metaVP.setAttribute('content', `width=${ Math.round(longestDimension * 1.4) }`);
    }
  }

  /**
   * Use on the 'remove' handler when the remaining tags in the list equals exactly 1.
   * Pretty crazy hack to fix bug in md-autocomplete, where when all items in list have been selected, then
   * you delete one, the list doesn't update. The fix adds a space, then removes, then hides this temporary
   * screen blocking mask that gets added by the dropdown (hides it rather than removes it because otherwise
   * the library throws and error when it tries to remove it).
   * Tested on Chrome 80
   */
  autoCompleteRefreshHack(controllerVM: any, searchTextPropName = 'searchText'): void {
    controllerVM[searchTextPropName] = ' ';
    setTimeout(() => {
      controllerVM[searchTextPropName] = '';
      setTimeout(() => {
        const scrollMask: any = document.querySelector('.md-scroll-mask');
        if (scrollMask) scrollMask.style.display = 'none';
      }, 0);
    }, 0);
  }

  htmlEncode(s: string): string {
    if (!s || typeof (s) !== "string") {
      return s;
    }

    return s.replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
  }

  htmlDecode(s: string, isNonTextField = false) {
    if (!s || typeof (s) !== "string") {
      return s;
    }
    if (isNonTextField) {
      return s.replace(/&amp;/g, '&')
        .replace(/&#39;/g, "'")
        .replace(/&#34;/g, '"')
        .replace(/&lt;/g, "<")
        .replace(/&gt;/g, ">");
    } else {
      return s.replace(/&amp;/g, '&')
        .replace(/&#39;/g, "'")
        .replace(/&#34;/g, '"');
    }
  }
}

// creates a singleton instance to export
const instance = new UtilsService();
export default instance as UtilsService;
